export const sleep = (seconds: number) => {
  return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
};



// WEBPACK FOOTER //
// /local/home/vibhorbh/workplace/Phoenix/src/utils/sleep.ts